var _path, _path2, _rect, _rect2, _rect3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClipboardGrey = function SvgClipboardGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 3.41663H4.16683C3.94582 3.41663 3.73385 3.50442 3.57757 3.6607C3.42129 3.81698 3.3335 4.02895 3.3335 4.24996V18C3.3335 18.221 3.42129 18.4329 3.57757 18.5892C3.73385 18.7455 3.94582 18.8333 4.16683 18.8333H15.8335C16.0545 18.8333 16.2665 18.7455 16.4228 18.5892C16.579 18.4329 16.6668 18.221 16.6668 18V4.24996C16.6668 4.02895 16.579 3.81698 16.4228 3.6607C16.2665 3.50442 16.0545 3.41663 15.8335 3.41663H12.9168",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0835 2.16663H12.9168V4.66663H7.0835V2.16663Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 8.75,
    width: 7.5,
    height: 0.5,
    rx: 0.25,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 11.75,
    width: 7.5,
    height: 0.5,
    rx: 0.25,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 14.75,
    width: 7.5,
    height: 0.5,
    rx: 0.25,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClipboardGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clipboard_grey.dda0608c.svg";
export { ForwardRef as ReactComponent };